import React, { Component } from 'react';
import {connect} from 'react-redux';
import {redirect_to_lab_website} from '../states/action';
import { Alert, Button, Badge, Row, Col } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faGlobe } from '@fortawesome/free-solid-svg-icons'

import { ImageSelector } from '../Util/Util';


import '../Styles/Shortlink_Authorization.css';
import '../Styles/shared.css';


class Shortlink_Authorization extends Component {

    state = { OTP: '', OTPError: '', logo: '', DirectToLabLoader: null }

    constructor(props) {
        super(props)

        this.onChnageOTP = this.onChnageOTP.bind(this);
        this.ShowResultReport = this.ShowResultReport.bind(this);
    }

    componentDidMount() {

        let logo = ImageSelector(this.props.Mylink.str_GUID)

        if (logo != '') {
            this.setState({ logo: logo });
        }

        //console.log("Shortlink_Authorization:componentDidMount");
        //console.log(this.context);
        //let DirectToLabLoader =  useContext(AppDataContext);
        //this.setState({ DirectToLabLoader: DirectToLabLoader });
    }

    ShowResultReport() {

        if (this.state.OTP != "") {
            if (this.state.OTP.length == 6) {

                let OTP = this.state.OTP;
                OTP = this.ReplacePersianUnicode(OTP);

                if (atob(atob(this.props.Mylink.int_RandomCode.toString())) != OTP) {
                    this.setState({ OTPError: "کد وارد شده صحیح نمی باشد" });
                }
                else {
                    //Redirect User to lab
                    //window.location.href = atob(atob(this.props.Mylink.str_OrginalURL));
                    //this.context.update({AuthPassed:true,str_LabPersianName:'ramin',Str_GUID:'ramin'});
                     this.props.dispatch(redirect_to_lab_website());
                }

            }
        }



    }

    onChnageOTP({ target }) {
        this.setState({ OTP: target.value });
        this.setState({ OTPError: "" });
    }

    ReplacePersianUnicode = (str) => {
        
        var persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
        var arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (var i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i.toString()).replace(arabicNumbers[i], i.toString());
            }
        }

        return str;
    };

    render() {

        return (
            <div className="content-text-center" >
                <Alert color="success"  >
                    <h1 className="small_header content-center content-text-center">جوابدهی آنلاین آزمایشگاه</h1>
                    <img className="img-fluid rounded-circle border lab-logo content-center" src={this.state.logo} alt=""></img>
                    <h1 className="Welcoming_LabName text-color-black content-text-center">به آزمایشگاه {this.props.Mylink.str_LabPersianName} خوش آمدید</h1>

                    <Row className="d-flex justify-content-center ">

                        <Col className="content-text-center">
                            <div className="content-text-center">
                                <a href={"tel:" + this.props.Mylink.str_DirectTel}>                          
                                    <p className="lab-contact-text">تلفن تماس:  {this.props.Mylink.str_DirectTel} <FontAwesomeIcon icon={faPhone}></FontAwesomeIcon></p>
                                </a>
                                <a href={this.props.Mylink.str_CommercialSiteAddress} target="_blank">                                
                                    {/* <p className="lab-contact-text"> {this.props.Mylink.str_CommercialSiteAddress} <FontAwesomeIcon icon={faGlobe}></FontAwesomeIcon></p> */}
                                    <p className="lab-contact-text-small content-text-center"> {this.props.Mylink.str_CommercialSiteAddress}</p>
                                </a>
                            </div>
                        </Col>



                        {/* <Col className="content-text-center">

                        </Col> */}
                    
                    </Row>


                    <div className="mt-4">

                        <AvForm onSubmit={this.ShowResultReport} >
                            <Badge className="content-center" color="primary">:لطفا کد پیامک شده را طبق راهنما وارد نمایید</Badge>
                            <AvField name="OTP" label="" type="text" errorMessage="!رمز وارد شده اشتباه است" onChange={this.onChnageOTP} validate={{
                                required: { value: true },
                                //pattern: { value: '^[0-9]+$' },
                                minLength: { value: 6 },
                                maxLength: { value: 6 }
                            }} />

                            <div>
                                <Badge className="content-center" color="danger">{this.state.OTPError}</Badge>
                            </div>
                            <Button type="submit" color="primary" className="mt-1" > نمایش گزارش جواب</Button>

                        </AvForm>

                    </div>

                </Alert>

            </div>
        )
    }

}


const mapStateToProps = state => {
    const UserAuthPass = state.UserAuthPass;
    return {UserAuthPass}
};

export default connect(mapStateToProps)(Shortlink_Authorization)